/* Floodlight · ss-pointer.js (core) — one delegated pointer engine: magnetic CTAs, card tilt + sheen,
   product zoom lens, guides cursor preview. Mouse only; motion parts off under reduced motion. */
(function () {
  'use strict';
  if (window.SS_LOADED_pointer) return;
  window.SS_LOADED_pointer = true;
  var SS = window.SS;
  if (!SS) return;
  var doc = document;
  var mag = null, tilt = null, pv = null, raf = 0, last = null;

  function resetMag() { if (mag) mag.style.transform = ''; mag = null; }
  function resetTilt() {
    if (tilt && tilt.firstElementChild) tilt.firstElementChild.style.transform = '';
    tilt = null;
  }
  function hidePv() { if (pv) pv.classList.remove('on'); pv = null; }
  function resetAll() { resetMag(); resetTilt(); hidePv(); }

  function run() {
    raf = 0;
    var e = last;
    if (!e) return;
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) { resetAll(); return; }
    var x = e.clientX, y = e.clientY, r;

    var zoom = t.closest('[data-zoom]');
    if (zoom) {
      r = zoom.getBoundingClientRect();
      zoom.style.setProperty('--zx', ((x - r.left) / r.width * 100).toFixed(1) + '%');
      zoom.style.setProperty('--zy', ((y - r.top) / r.height * 100).toFixed(1) + '%');
    }
    if (SS.reduced) { resetAll(); return; }

    var row = t.closest('.gx-row');
    var gx = row ? row.closest('[data-gx]') : null;
    var box = gx ? gx.querySelector('.gx-pv') : null;
    if (row && box) {
      if (pv && pv !== box) hidePv();
      r = gx.getBoundingClientRect();
      var lx = x - r.left, ly = y - r.top;
      var px = lx > r.width - 330 ? lx - 300 : lx + 40;
      var i = row.getAttribute('data-i') || '';
      if (box.getAttribute('data-i') !== i) {
        box.setAttribute('data-i', i);
        SS.qsa('img[data-i]', box).forEach(function (img) { img.classList.toggle('on', img.getAttribute('data-i') === i); });
      }
      box.style.setProperty('--px', px.toFixed(0) + 'px');
      box.style.setProperty('--py', (ly - 110).toFixed(0) + 'px');
      box.classList.add('on');
      pv = box;
    } else hidePv();

    var m = t.closest('.mag');
    if (m !== mag) resetMag();
    if (m && !m.disabled) {
      r = m.getBoundingClientRect();
      var dx = (x - r.left - r.width / 2) * 0.18, dy = (y - r.top - r.height / 2) * 0.32;
      m.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
      mag = m;
    }

    var card = t.closest('[data-tilt]');
    if (card !== tilt) resetTilt();
    if (!card || !card.firstElementChild) return;
    tilt = card;
    var inner = card.firstElementChild;
    r = card.getBoundingClientRect();
    var fx = (x - r.left) / r.width, fy = (y - r.top) / r.height;
    inner.style.setProperty('--mx', (fx * 100).toFixed(1) + '%');
    inner.style.setProperty('--my', (fy * 100).toFixed(1) + '%');
    inner.style.transform = 'translateY(-10px) rotateX(' + ((0.5 - fy) * 7).toFixed(2) + 'deg) rotateY(' + ((fx - 0.5) * 9).toFixed(2) + 'deg)';
  }

  doc.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    last = e;
    if (!raf) raf = requestAnimationFrame(run);
  }, { passive: true });
  doc.documentElement.addEventListener('pointerleave', function () { last = null; resetAll(); });
  window.addEventListener('blur', resetAll);
  SS.on('motion', function (d) { if (d.reduced) resetAll(); });
  SS.on('overlay:open', resetAll);
})();
